interface Props {
  children: React.ReactNode;
}

export default function Alert({ children }: Props) {
  return (
    <div
      role="alert"
      className="relative mb-4 rounded-md border border-solid border-emerald-200 bg-emerald-100 p-4 text-green-950"
    >
      {children}
    </div>
  );
}
